export const SPOTIFY_AUTH_STATE_KEY = "homehub.spotify.authState";
export const SPOTIFY_AUTH_VERIFIER_KEY = "homehub.spotify.authVerifier";
export const SPOTIFY_AUTH_CHANGED_EVENT = "homehub:spotify-auth-changed";

const SPOTIFY_SCOPES = [
  "streaming",
  "user-read-email",
  "user-read-private",
  "user-read-playback-state",
  "user-modify-playback-state",
  "user-read-currently-playing",
].join(" ");

const randomString = (length: number): string => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const values = crypto.getRandomValues(new Uint8Array(length));

  return Array.from(values)
    .map((value) => chars[value % chars.length])
    .join("");
};

const sha256 = async (plain: string): Promise<ArrayBuffer> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return crypto.subtle.digest("SHA-256", data);
};

const base64UrlEncode = (input: Uint8Array): string => {
  const bytes = Array.from(input)
    .map((byte) => String.fromCharCode(byte))
    .join("");

  return btoa(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const createCodeChallenge = async (verifier: string): Promise<string> => {
  const digest = await sha256(verifier);
  return base64UrlEncode(new Uint8Array(digest));
};

export const emitSpotifyAuthChanged = () => {
  window.dispatchEvent(new Event(SPOTIFY_AUTH_CHANGED_EVENT));
};

export const clearSpotifyAuthScratchKeys = () => {
  localStorage.removeItem(SPOTIFY_AUTH_STATE_KEY);
  localStorage.removeItem(SPOTIFY_AUTH_VERIFIER_KEY);
};

export const buildSpotifyAuthorizeUrl = async (
  clientId: string,
  redirectUri: string,
): Promise<string> => {
  const state = randomString(16);
  const verifier = randomString(64);
  const challenge = await createCodeChallenge(verifier);

  localStorage.setItem(SPOTIFY_AUTH_STATE_KEY, state);
  localStorage.setItem(SPOTIFY_AUTH_VERIFIER_KEY, verifier);

  const params = new URLSearchParams({
    client_id: clientId,
    response_type: "code",
    redirect_uri: redirectUri,
    code_challenge_method: "S256",
    code_challenge: challenge,
    state,
    scope: SPOTIFY_SCOPES,
  });

  return `https://accounts.spotify.com/authorize?${params.toString()}`;
};
